exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preloader-backdrop {\r\n  background-color: transparent;\r\n}\r\n.page-preloader {\r\n  background-color: #fff;\r\n  box-shadow: 0 5px 20px #d6dee4;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/projects/passengerControlFront/passengerControlApp/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main